import script from "./InterviewStatusTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./InterviewStatusTag.vue?vue&type=script&setup=true&lang=ts"

import "./InterviewStatusTag.vue?vue&type=style&index=0&id=205c7a49&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-205c7a49"]])

export default __exports__